<template>
    <div class="customer-profile registration-customer-form">
        <div class="content-area">
            <base-header
                :menu-listing="getMenuListing"
                step-style
                @sidemenu="$emit('responsiveSideBar')"
            ></base-header>
            <div class="right-panel">
                <div class="wrap-content customer-section">
                    <div class="filter-section">
                        <div class="row">
                            <div class="col-md-12">
                                <h2>{{ $route.meta.name }}</h2>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <router-view></router-view>
                        <!-- <b-modal
                            ref="modalError"
                            size="md"
                            title="Welcome to Idenfo Direct"
                            hide-footer
                            hide-header-close
                            :click-to-close="false"
                            :no-close-on-backdrop="true"
                            :no-close-on-esc="true"
                        >
                            <div class="modal-body-disclaimer">
                                <p class="paragraph">
                                    Your profile limit has been exceeded!
                                </p>
                                <div class="row justify-content-center">
                                    <div class="m-2">
                                        <b-button
                                            variant="secondary"
                                            @click="currentPlan"
                                            >Okay</b-button
                                        >
                                    </div>
                                </div>
                            </div>
                        </b-modal> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'
import resource from '@/api/resource'

const modulesApi = new resource('configurations/modules')

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            liveness: null,
            nameScreening: null,
            riskFactor: null,
            documentUpload: null,
            menuListing: [
                {
                    // anchorLink: '/register-customer/upload-document',
                    menuLabel: 'Upload Documents',
                    sessionStep: '1',
                    name: 'upload-document',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/account-info',
                    menuLabel: 'Preview',
                    sessionStep: '2',
                    name: 'upload-document',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/finish',
                    menuLabel: 'Finish',
                    sessionStep: '3',
                    name: 'upload-document',
                    permission: ['register-customer'],
                },
            ],
            userCompanyType: '',
            configData: {
                dataSegmentId: null,
                riskFactor: null,
                liveness: null,
                nameScreening: null,
                documentUpload: null,
                companyType: null,
                counter: null,
                subscription: null,
                tier: null,
                restrictDuplicateCustomers: null,
            },
            customersCount: 0,
            showPageLoader: true,
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                status: null,
                sortBy: 'idenfoId',
                sortOrder: 'desc',
            },
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['form', 'dataSegmentId']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },

        // userToken() {
        //     if (this.$route.params.token) {
        //         return this.$route.params.token
        //     }
        //     return this.$store.getters.token
        // },

        getMenuListing() {
            let arr = this.menuListing
            // for (var key in arr) {
            //     if (this.documentUpload == false && arr[key].sessionStep == 1) {
            //         arr.splice(key, 1)
            //     }
            //     if (
            //         (this.liveness == false ||
            //             this.$store.getters.form.type == 'company') &&
            //         arr[key].sessionStep == 2
            //     ) {
            //         arr.splice(key, 1)
            //     }
            //     if (this.nameScreening == false && arr[key].sessionStep == 3) {
            //         arr.splice(key, 1)
            //     }
            //     // if (this.riskFactor == false && arr[key].sessionStep == 4) {
            //     //     arr.splice(key, 1)
            //     // }
            //     if (
            //         (this.configData.additionalInfo == false ||
            //             this.$store.getters.form.type == 'company') &&
            //         arr[key].sessionStep == 5
            //     ) {
            //         arr.splice(key, 1)
            //     }
            //     // if (this.userCompanyType == 'non-financial' && arr[key].sessionStep == 4) {
            //     //     arr.splice(key, 1)
            //     // }
            // }
            return arr
        },
    }, // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.goToFirstStep()
                //    this.checkOcrSwitch()
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    async mounted() {
        this.$store.commit('initDefaultFields', 'form')
        console.log('-------------im customer forms', this.$store.getters.form)
        await this.checkDocumentTempExistAndNotExpired()
        await this.goToFirstStep()
        
        // if (this.$route.path.includes('deep')) {
        //     await this.checkTempUser()
        // } else {
        //     await this.checkDataSegment()
        // }
        await this.getModuleData()
        // await this.getCounter()

        //  this.checkOcrSwitch()
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * go to the first step
         *
         * @return {void}
         */
         async checkDocumentTempExistAndNotExpired() {
            try {
                let params = this.$route.params
                let dataSegmentId = params.dataSegmentId
                let userToken = params.token
                console.log(params)

                const formData = {
                    userToken: userToken,
                    dataSegmentId: dataSegmentId,
                }

                let { data } = await request({
                    url: `/customers/temp-document-upload-exist`,
                    method: 'post',
                    data: formData,
                })

                if (data) {
                    console.log('Response: ' + JSON.stringify(data))
                    console.log('Response: ' + JSON.stringify(data.exists))
                    if (!data.exists) {
                        this.$router.push({
                            name: '/404',
                        })
                    }
                }
            } catch (error) {
                // console.log(error)
            }
        },
        async getModuleData() {
            try {
                if (this.dataSegmentId) {
                    let { data } = await modulesApi.list({
                        dataSegmentId: this.dataSegmentId,
                    })
                    if (!_.isEmpty(data.data)) {
                        this.liveness = data.data.liveness
                        this.nameScreening = data.data.nameScreening
                        this.riskFactor = data.data.riskFactor
                        this.documentUpload = data.data.documentUpload
                        this.$store.state.configData = data.data
                        this.configData = data.data
                        this.$store.state.registration.configData = data.data
                        // console.log('configData', this.configData)
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },
        goToFirstStep() {
            if (
                ![
                    'upload-document',
                    'document-upload-upload-document',
                ].includes(this.$route.name)
            ) {
                if (this.$route.meta.publicRegistration === true) {
                    this.$router.push({
                        name: 'document-upload-upload-document',
                        params: {
                            dataSegmentId: this.dataSegmentId,
                        },
                    })
                } else {
                    this.$router.push({
                        name: 'upload-document',
                    })
                }
            }
        }, // End of goToFirstStep() method
        /**
         * check if the ocr switch configurations
         * is on for this data segment
         *
         * @return {void}
         */
        // async checkTempUser() {
        //     try {
        //         let params = this.$route.params
        //         let dataSegmentId = params.dataSegmentId
        //         let userToken = params.token
        //         console.log(params)

        //         const formData = {
        //             userToken: userToken,
        //             dataSegmentId: dataSegmentId,
        //         }

        //         let { data } = await request({
        //             url: `/customers/temp-customer-exists`,
        //             method: 'post',
        //             data: formData,
        //         })

        //         if (data) {
        //             console.log('Response: ' + JSON.stringify(data))
        //             console.log('Response: ' + JSON.stringify(data.exists))
        //             if (!data.exists) {
        //                 this.$router.push({
        //                     name: '/404',
        //                 })
        //             }
        //         }
        //     } catch (error) {
        //         // console.log(error)
        //     }
        // },

        // async checkDataSegment() {
        //     try {
        //         let params = this.$route.params
        //         let dataSegmentId = params.dataSegmentId

        //         const formData = {
        //             dataSegmentId: dataSegmentId,
        //         }

        //         let { data } = await request({
        //             url: `/customers/data-segment-exists`,
        //             method: 'post',
        //             data: formData,
        //         })

        //         if (data) {
        //             console.log('Response: ' + JSON.stringify(data))
        //             console.log('Response: ' + JSON.stringify(data.exists))
        //             if (!data.exists) {
        //                 this.$router.push({
        //                     name: '/404',
        //                 })
        //             }
        //         }
        //     } catch (error) {
        //         console.log(error)
        //     }
        // },
        // End of checkOcrSwitch() method

        // async getUserByDataSegmentId() {
        //     console.log('GetUSer')

        //     let { data } = await request({
        //         url: `/users/getUserByDataSegmentId/${this.dataSegmentId}`,
        //         method: 'get',
        //     })

        //     if (data) {
        //         // console.log(data)
        //         this.userCompanyType = data.data.companyType

        //         this.$store.commit('updateField', {
        //             key: 'companyType',
        //             value: this.userCompanyType,
        //         })
        //     }
        // },

        // async checkCustomersCount() {
        //     try {
        //         let params = this.$route.params
        //         let dataSegmentId = params.dataSegmentId

        //         const formData = {
        //             dataSegmentId: dataSegmentId,
        //         }

        //         let { data } = await request({
        //             url: `/customers/count`,
        //             method: 'post',
        //             data: formData,
        //         })

        //         if (data) {
        //             console.log('Response: ' + JSON.stringify(data))
        //             this.customersCount = data.data
        //         }
        //     } catch (error) {
        //         console.log(error)
        //     }
        // },

        // async getCounter() {
        //     if (this.configData.subscription == 'unpaid') {
        //         this.configData.counter = 0
        //     }

        //     this.$store.commit('showPageLoader', true)
        //     try {
        //         this.resourceApi = new resource('users/count-applications')
        //         let params = {
        //             dataSegmentId: this.dataSegmentId,
        //         }
        //         let { data } = await this.resourceApi.list(params)
        //         if (data && data.tierAttains) {
        //             this.$refs.modalError.show()
        //         }
        //         // False the page loader after the list has been loaded
        //         this.$store.commit('showPageLoader', false)
        //         this.$store.commit('setLoading', false)
        //     } catch (error) {
        //         this.$store.commit('showPageLoader', false)
        //         this.$store.commit('setLoading', false)
        //         // this.$store.commit('setError', error)
        //     }
        // },

        // payments() {
        //     this.$refs.modalError.hide()
        //     this.$router.push('/billing')
        // },
        // currentPlan() {
        //     this.$refs.modalError.hide()
        //     this.$router.push('/customer-profiles')
        // },
    }, // End of Component > watch
} // End of export default
</script>
